Array.prototype.plunk = function(fn) {
  return Object(this).
      reduce(
          (carry, item) => carry.set(fn(item), item),
          new Map(),
      );
};
